import React, { useState, useContext, useEffect } from 'react'
import './reviewSlider.css'
import Button from './button'
import ReactSlider from 'react-slider'
import ReactModal from 'react-modal';
import {useHistory} from 'react-router-dom';

import CalculatorContext from '../Context'

function ReviewSlider() {    
  const history = useHistory();

  const context = useContext(CalculatorContext)
  const {price, carbon, percent, setPercent} = context;
  const totalValue = context.amount;
  const changeTotal = context.setAmount;
  
  const [amount, setAmount] = useState(totalValue? totalValue: (carbon * price).toFixed(2))
  const [showModal, setShowModal] = useState(false)

  const changeAmount= (newAmount, fixed=false)=>{   
    setAmount(fixed? Number(newAmount).toFixed(2): newAmount)      
    let newPercent = Number(newAmount) / (carbon * price) *100;    
    newPercent = Math.min(newPercent, 200)
    newPercent = Math.max(newPercent, 100)
    setPercent(newPercent)    
    changeTotal(Number(newAmount).toFixed(2))
  }
  const fixAmount =()=>{
    if( isNaN(Number(amount)) || Number(amount)< 0 ) {
      return changeAmount(Number(carbon * price).toFixed(2))
    }
    changeAmount(Number(amount).toFixed(2))
  }
  useEffect(()=>{
    setAmount(totalValue)
  },[totalValue])
  
  const checkout = ()=>{
    setShowModal(true)
  }

  const handleCloseModal = () =>{
    setShowModal(false)
  }
  const handleContinue = () => {
    const productId =window.calculator_options.widget_carbon_offset
    //const productId = '2427'
    const qty = amount / 0.000015;
    window.open(`/checkout/?add-to-cart=${productId}&quantity=${qty}`, '_blank');
  }

  return (
    <div className="review-slider">
      <div className="title-review">
        <div className="section-review section-1" onClick={()=> changeAmount(carbon * price*1, true)}>
          <div className="review-value">100%</div>
          <div>Carbon Neutral</div>
          <div className="horizontal-line-review"/>
        </div>
        <div className="section-review section-2" onClick={()=> changeAmount(carbon * price *1.5, true)}>
          <div className="review-value">150%</div>
          <div>Above & Beyond</div>
          <div className="horizontal-line-review"/>
        </div>
        <div className="section-review section-3" onClick={()=> changeAmount(carbon * price *2, true)}>
          <div className="review-value">200%</div>
          <div>Double your Commitment</div>
          <div className="horizontal-line-review"/>
        </div>
      </div>
      
      <div className="review-slider-component">
        <div className="review-slider-line section-1">
          <div className="review-slider-up"/>
          <div className="review-slider-down"/>
        </div>
        <div className="review-slider-line section-2">
          <div className="review-slider-up"/>
          <div className="review-slider-down"/>
        </div>
        <div className="review-slider-line section-3">
          <div className="review-slider-up"/>
          <div className="review-slider-down"/>
        </div>
      </div>
      <div className="react-slider-wrapper">
        <div className="react-slider-container">
          <ReactSlider
              value={percent}
              min={100}
              max={200}
              onChange={(value)=> changeAmount(carbon * price * value /100, true)}
              className="review-slider-slider"
              thumbClassName="review-thumb"
              trackClassName="review-track"
              
          />
        </div>
      </div>
      <div className="review-form">
        <div className="review-or">
          <span>—</span> OR <span>—</span>
        </div>
        <div className="review-input-wrapper">
          <input  value={amount} className="review-input" onChange={(ev)=> setAmount( ev.target.value) } onBlur={fixAmount}/>
        </div>
          <Button onClick={checkout} className="checkout">CHECKOUT NOW</Button>
      </div>
      <ReactModal 
           isOpen={showModal}   
           closeTimeoutMS={300}    
           style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
              zIndex:2
            },
            content: {
              position: 'absolute',
              top: "calc(50% - 160px)",
              left: "calc(50% - 160px)",
              width: 280,
              height:300,
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              outline: 'none',
              padding: '20px',
              zIndex:2
            }
           }}
        >
          <div className="leaving-text">
            You will be taken to tradewater.co to complete your transaction.
          </div>
          <div className="leaving-buttons">
            <Button onClick={handleCloseModal} showImage={false}>Cancel</Button>
            <Button onClick={handleContinue}>Continue</Button>            
          </div>
      </ReactModal>
    </div>

  )


}


export default ReviewSlider